<template>
  <Home/>
</template>

<script>
import Home from '@/components/Home'
import { Vue, Component } from 'vue-property-decorator'

@Component({
  components: {
    Home
  }
})
export default class HomView extends Vue {
}
</script>
